import { useCallback } from 'react'
import type { ChatMessage } from '../../shared/types/chat'

export function useMessageUpdate(
  setMessages: React.Dispatch<React.SetStateAction<ChatMessage[]>>
) {
  return useCallback(
    (messageId: string, updater: (msg: ChatMessage) => ChatMessage) => {
      setMessages(prev => prev.map(msg =>
        msg.id === messageId ? updater(msg) : msg
      ))
    },
    [setMessages]
  )
}
